/* eslint-disable no-undef, camelcase, no-underscore-dangle */

// Used by styled-components
window.__webpack_nonce__ = window.NONCE_ID;

// Used by webpack
__webpack_nonce__ = window.NONCE_ID;
